/**
 * List of team
 * @enum {string}
 */
export let Team = /*#__PURE__*/function (Team) {
  Team["Checkout"] = "Checkout";
  Team["Growth"] = "Growth";
  Team["Presentation"] = "Presentation";
  Team["OrderManagement"] = "OrderManagement";
  Team["Payment"] = "Payment";
  Team["Acquisition"] = "Acquisition";
  Team["Framework"] = "Framework";
  Team["Backend"] = "Backend";
  Team["SellingTools"] = "SellingTools";
  Team["AcquisitionGrowth"] = "AcquisitionGrowth";
  return Team;
}({});
//# sourceMappingURL=Team.js.map